export const BASE_URL: string = "https://api.driveplus.app/api"
export const LOGIN_URL: string = "https://api.driveplus.app/api/auth/login"
export const REGISTER_URL: string = "https://api.driveplus.app/api/auth/sign-up"
export const LOGOUT_URL: string = "https://api.driveplus.app/api/auth/logout"

export const CUSTOMER_KEY: string = 'customer'